export const AUTH_CALLBACK_PATH = 'callback';
export const ROOT_PATH = '/';
export const E_SIGN_MSG_ADVISOR_PATH = 'electronicsignature-advisor';
export const PRODUCT_PATH = 'product/:productCode';
export const CONTEXT_PATH = 'context/:id';
export const SIGNATURE_STATUS_PATH = 'signature/status/:status';
export const START_CONTEXT_PATH = 'start/:context';
export const START_CONTEXT_PRODUCT_PATH = 'start/:context/:product';
export const START_PATH = 'start';
export const SUBSCRIPTION_PATH = 'subscription';

/* Common */
export const SUBSCRIBER_PATH = 'subscriber';
export const OFFER_CUSTOMIZE_PATH = 'offer-customize';
export const QUOTE_CONFIRMATION_PATH = 'quote-confirmation';
export const DIRECT_DEBIT_PATH = 'direct-debit';
export const SPECIAL_CONDITIONS_PATH = 'special-conditions';
export const CONFIRMATION_PATH = 'confirmation';
export const ERROR_404_PATH = 'error-404';
export const E_SIGN_MSG_PATH = 'e_sign_msg';
export const E_SIGN_MSG_STATUS_PATH = 'e_sign_msg/:status';
export const CONTRACT_VALIDATION_PATH = 'contract-validation';
export const CROSS_SELLING_C_PATH = 'cross-selling-c';
export const CROSS_SELLING_W_PATH = 'cross-selling-w';
export const ERROR_EMAIL_PATH = 'error-email';

/* Parcours */
export const INFORMATION_PATH = 'information';
export const ADDRESS_PATH = 'address';
export const ELIGIBILITY_PATH = 'eligibility';
export const HOUSING_USE_PATH = 'housing-use';
export const HOUSING_TYPE_PATH = 'housing-type';
export const HOUSING_TENANT_PATH = 'housing-tenant';
export const OCCUPATION_TYPE_PATH = 'occupation-type';
export const HOUSING_RESIDENT_PATH = 'housing-resident';
export const LESSOR_PATH = 'lessor';
export const STUDENT_AGE_PATH = 'student-age';
export const SINISTER_HISTORY_PATH = 'sinister-history';
export const NUMBER_PIECES_PATH = 'number-pieces';
export const DEPTHS_PATH = 'dependances';
export const DURABLE_DEVELOPMENT_PATH = 'durable-development';
export const SWIMMING_POOL_PATH = 'swimming-pool';
export const INSURED_VALUE_PATH = 'insured-value';
export const SURFACE_DEPENDANCES_PATH = 'surface-dependances';
export const CEILING_REINFORCEMENT_PATH = 'ceiling-reinforcement';
export const OPTIONS_PATH = 'options';
export const PREFERENTIAL_RATE_PATH = 'preferential-rate';
export const REVENUS_PATH = 'revenus';
export const SCHOOL_INSURANCE_PATH = 'school-insurance';
export const OFFER_CUSTOMIZATION_PATH = 'offer-customization';
export const LESSOR_NOTIFICATION_PATH = 'lessor-notification';
export const INSURER_RESILIATION_PATH = 'insurer-resiliation';
export const ROOMMATES_INFO_PATH = 'roommates-information';
// ESSENTIELLE SPECIFIC PATHS
export const PERSONALIZATION_PATH = 'personalization';
export const COMPLEMENT_PATH = 'supplements';
